module.exports = __webpack_public_path__ + "img/defaultVoucherIco.efd435ca.png";